module.exports = __webpack_public_path__ + "img/WTA-Player-Zone_Headers.b1ba4b60.png";